import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { FamilyEvent } from './FamilyEvent.js';

@Entity()
export class FamilyRegistration extends MongoEntity {
  static override _class = 'FamilyRegistration';
  static override _collectionName = 'family-registrations';

  @validate(nonOptional())
  @Field(() => String)
  public eventID: Maybe<string>;

  @DataLoadedField(() => FamilyEvent, ({ eventID }) => eventID)
  public event: Maybe<FamilyEvent>;

  @Field(() => String)
  public vorname: Maybe<string>;

  @Field(() => String)
  public nachname: Maybe<string>;

  @Field(() => String)
  public email: Maybe<string>;

  @Field(() => String)
  public sprachbedarf: Maybe<string>;
}
